<template>
    <layout>
        <!-- Map View -->
        <div class="block" v-if="inspections.length || this.isAdmin">

            <!-- Parcels map -->
            <parcel-map ref="parcelMap" 
                :parcels="parcels"                 
                :centroids="centroids"
                :interactive="false"
                :allowDrawing="false"

                @click="onClickFeature"
               

                class="map-container pullmeup full-width"
                style="height: 400px; top:0; bottom:0;">
            </parcel-map>
             <!-- @enter="onEnterFeature"
                @leave="onLeaveFeature" -->
            <!-- <pre id='features'></pre> -->

        </div>

    	<!-- Controls -->
    	<div class="row" v-if="inspections.length || this.isAdmin">
    		<div class="col-xs-12">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="row">
    						<div class="col-sm-6">
    							<div class="input-group">
    								<input class="form-control" type="text" placeholder="Search inspections" v-model="search" v-on:keyup.enter="searchInspections">
    								<span class="input-group-btn">
    									<button class="btn btn-default" type="button" @click="searchInspections"><i class="fa fa-search"></i> Search</button>
    								</span>
    							</div>
    						</div>
    						<div class="visible-xs push-10"></div>
    						<div class="col-sm-3">
    							<select class="form-control" v-model="region_filter">
    								<option value=''>All</option>
    								<option value='al'>Alabama</option>
    								<option value='fl'>Florida</option>
    							</select>
    						</div>
                            <div class="visible-xs push-10"></div>
    						<div class="col-sm-3">
    							<select class="form-control" v-model="status_filter">
    								<option value=''>All</option>
    								<option value='not_submitted'>Draft</option>
    								<option value='submitted'>Submitted</option>
    								<option value='validated'>Approved</option>
    								<option value='rejected'>Rejected</option>
    								<option value='modified'>Modified</option>
    							</select>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<!-- END controls -->

        <!-- Inspections table -->
        <div :class="[(working) ? 'block-opt-refresh' : '', 'block', 'block-rounded']">
            <div v-if="inspections.length || working || !isInspector">
                <div class="block-content" style="min-height: 400px;">
                    <div class="inspection-table">
                        <inspection-list ref="list" :inspections="inspections" :columns="inspectionListColumns" @deleteInspection="deleteInspectionCheck"/>
                    </div>
                </div>

                <div class="text-center">
                    <page-thingy v-if="inspections.length" :count="inspectionDisplayCount" :page="inspectionDisplayPage_1base" :total="inspectionDisplayTotal" @go="go"/>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-md-6 col-md-offset-3">
                    <div class="text-center text-muted" style="padding-top: 60px;">
                        <p><i class="icon-ghost" style="font-size: 100px;"></i></p>
                        <div>

                            <h5 style="margin-bottom: 20px;">It looks like you haven't yet created an inspection.</h5>
                            <h4 style="margin-bottom: 20px;">Click below to get started!</h4>

                            <button type="button" class="btn btn-lg btn-success" style="margin: 40px;" @click="newInspection">
                                <i class="fa fa-plus push-5-r"></i> New Inspection
                            </button>

                            <p/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    	<!-- END Landowners table -->

    </layout>
</template>

<script>
    var mapboxgl = require("mapbox-gl");
    var turfBBox = require("@turf/bbox").default;
    
    import inspectionMixin from '../../mixins/inspections-api-mixin.js';
    import roleMixin from '../../mixins/role-mixins.js';

    
    export default {
        mixins: [ inspectionMixin, roleMixin ],
        name: 'inspections',
        components: {
            layout: require('../layouts/default.vue'),
            inspectionList: require('../elements/inspection-list.vue'),
            pageThingy: require('../elements/page-thingy.vue'),
            parcelMap: require('../elements/map.vue'),
        },
        data () {
            return {
                search: '',
                region_filter: '',
                status_filter: '',
                working: true,
                inspectionDisplayCount: 15,
                inspectionDisplayPage_1base: 1,
            }
        },
        computed: {
            inspectionListColumns() {
                return this.isAdmin ? ['inspector', 'contact', 'delete'] : ['contact', 'delete'];    // TODO, others (doesn't look for them)
            },
            inspectionDisplaySkip() {
                return (this.inspectionDisplayPage_1base-1)*this.inspectionDisplayCount;
            },
            inspectionDisplayTotal() {
                return this.inspectionsMeta.total;
            },
            parcels () {
                let parcels = [];

                _.each(this.inspections, (inspection) => {
                    _.each(inspection.parcels.data, (parcel) => {
                        parcels.push(Object.assign(parcel, {
                            type: "parcel",
                            inspection_id: inspection.id,
                        }));
                    });
                });

                return parcels;
            },
            missingMarkers () {
                let markers = [];

                _.each(this.inspections, (inspection) => {
                    _.each(inspection.data.parcels.missing_parcels, (missingParcel) => {
                        markers.push({
                            //http://www.lass.it/Web/viewer.aspx?id=4
                            type: 'missing', //
                            id: Math.random().toString(36),
                            inspection_id: inspection.id,
                            position: new mapboxgl.LngLat(missingParcel.lng, missingParcel.lat),
                        });
                    });
                });

                return markers;
            },
            centroids () {
                let centroids = [];

                _.each(this.inspections, (inspection) => {
                    let bounds = new mapboxgl.LngLatBounds();

                    _.each(inspection.parcels.data, (parcel) => {
                        let bbox = turfBBox(JSON.parse(parcel.geom));

                        bounds.extend(new mapboxgl.LngLat(bbox[0], bbox[1]));
                        bounds.extend(new mapboxgl.LngLat(bbox[2], bbox[3]));
                    });

                    _.each(inspection.data.parcels.missing_parcels, (missingParcel) => {
                        bounds.extend(new mapboxgl.LngLat(missingParcel.lng, missingParcel.lat));                        
                    });

                    try {
                        centroids.push({
                            //http://www.lass.it/Web/viewer.aspx?id=4
                            type: 'centroid', //
                            id: Math.random().toString(36),
                            inspection_id: inspection.id,
                            position: new mapboxgl.LngLat(bounds.getCenter().lng, bounds.getCenter().lat),
                        });
                    } catch(e) {
                        console.warn("Warning: parcel bounds did not compute: " + e.toString());
                    }
                });

                return centroids;
            }
        },
        watch: {
            // search: function () {
            //     let self = this;
            //     this.working = true;
            //     this.queryInspections(this.search, this.region_filter, this.status_filter, () => { self.working = false; });
            // },

            region_filter: function () {
                let self = this;
                this.working = true;
                this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, () => { self.working = false; });
            },

            status_filter: function () {
                let self = this;
                this.working = true;
                this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, () => { self.working = false; });
            },
            map: function () {
            }
        },
        methods: {

            renderParcels(inspections) {

                // this.parcels = [];
                // this.missingMarkers = [];

                // _.each(inspections, (inspection) => {
                //     _.each(inspection.parcels.data, (parcel) => {
                //         this.parcels.push(parcel);
                //     });

                //     _.each(inspection.data.parcels.missing_parcels, (missingParcel) => {
                //         this.missingMarkers.push({
                //             //http://www.lass.it/Web/viewer.aspx?id=4
                //             icon: 'park', //
                //             position: new mapboxgl.LngLat(missingParcel.lng, missingParcel.lat),
                //         });
                //     });
                // });

                // if(this.map) {
                //     let parcelIds = [];

                //     _.each(inspections, (inspection) => {
                //         _.each(inspection.parcels.data, function (parcel) {
                //             parcelIds.push(parcel.pid);
                //         });
                //     });

                //     this.map.setFilter("certpilot-highlighted", ['in', 'id'].concat(parcelIds));
                // }

            },

            onClickFeature(feature) {
                if(feature && feature.inspection_id) {
                    this.$refs.parcelMap.unsetMap();
                    this.$router.push('inspections/' + feature.inspection_id);
                }
            },
            // onEnterFeature(featureProperties) {
            //     let inspectionId = featureProperties.inspection_id;

            //     this.overlays.forEach((o) => {
            //         if (o.inspectionId == inspectionId) {
            //             o.setOptions({ fillColor: '#754191',  strokeColor: '#754191' });
            //         }
            //     });
            // },
            // onLeaveFeature(featureProperties) {
            //     this.$router.push('inspections/' + featureProperties.inspection_id);
            // },
            // Init hover event listeners to highlight corresponding polygon(s) on map
            // jQuery('body').on('mouseover', '.inspection-table tbody tr', (e) => {
            //     let inspectionId = jQuery(e.currentTarget).data('id');

            //     self.overlays.forEach((o) => {
            //         if (o.inspectionId == inspectionId) {
            //             o.setOptions({ fillColor: '#754191',  strokeColor: '#754191' });
            //         }
            //     });
            // });

            // jQuery('body').on('mouseout', '.inspection-table tbody tr', (e) => {
            //     let inspectionId = jQuery(e.currentTarget).data('id');

            //     self.overlays.forEach((o) => {
            //         if (o.inspectionId == inspectionId) {
            //             o.setOptions({ strokeColor: '#5ab74a', fillColor: '#5ab74a' });
            //         }
            //     });
            // });

            getParcelCenter(inspection) {
                if(inspection.parcel_count <= 0) return null;

                let bounds = new mapboxgl.LngLatBounds();

                _.each(inspection.parcels.data, function (parcel) {
                    let geom = JSON.parse(parcel.geom);

                    _.each(geom.coordinates, function(multi) {
                        _.each(multi, function(poly) {
                            _.each(poly, function(pt) {
                                var latLngObj = new mapboxgl.LngLat(pt[1], pt[0]);
                                bounds.extend(latLngObj);
                            });
                        });
                    });
                });

                return bounds.getCenter();
            },

            searchInspections() {
                let self = this;
                this.working = true;
                this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, () => { self.working = false; });
            },

            go(page_1base) {
                this.inspectionDisplayPage_1base = page_1base;
                this.searchInspections();
            },

            deleteInspectionCheck(args) {
                let inspectionId = args[0].id
                this.$swal({
                    title: "Are you sure?",
                    text: "Deletion will permanantly remove this inspection!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        return this.axios.post(`inspections/${inspectionId}/deactivate`).then((result) => {
                            this.searchInspections();
                            this.$swal(
                                'Deleted!',
                                'The inspection has been removed.',
                                'success'
                            )
                        });
                    }
                });
            },

            newInspection () {
                // TODO: remove code dupe (this func is in home)
                this.createInspection().then((response) => {
                    this.$router.push('/inspections/' + response.data.id);
                });
            },
        },
        mounted () {
            let self = this;

            // Init hover event listeners to highlight corresponding polygon(s) on map
            // jQuery('body').on('mouseover', '.inspection-table tbody tr', (e) => {
            //     let inspectionId = jQuery(e.currentTarget).data('id');

            //     self.overlays.forEach((o) => {
            //         if (o.inspectionId == inspectionId) {
            //             o.setOptions({ fillColor: '#754191',  strokeColor: '#754191' });
            //         }
            //     });
            // });

            // jQuery('body').on('mouseout', '.inspection-table tbody tr', (e) => {
            //     let inspectionId = jQuery(e.currentTarget).data('id');

            //     self.overlays.forEach((o) => {
            //         if (o.inspectionId == inspectionId) {
            //             o.setOptions({ strokeColor: '#5ab74a', fillColor: '#5ab74a' });
            //         }
            //     });
            // });

            if(this.$route.params.status_filter) {
                this.status_filter = this.$route.params.status_filter;
            }

            this.queryInspections(this.search, this.inspectionListColumns.join(','), this.region_filter, this.status_filter, this.inspectionDisplayCount, this.inspectionDisplaySkip, (inspections, meta) => {
                self.working = false;
            });
        }
    };
</script>



// WEBPACK FOOTER //
// inspections.vue?5fd7fd7e